import React from "react";
import { useNavigate } from "react-router-dom";
import { Calendar, UserPen } from "lucide-react";
import { format, parseISO } from "date-fns";

const BlogCard = ({ data }) => {
  const navigate = useNavigate();

  const handleNavigate = (data) => {
    navigate(`/blog/${data?.id}`, { state: { data } });
  };

  return (
    <div
      key={data?.id}
      onClick={() => handleNavigate(data)}
      className="bg-white shadow-sm overflow-hidden h-full transition-all duration-300 hover:shadow-md hover:scale-95 cursor-pointer"
    >
      <img
        src={data?.coverImage}
        alt={data?.id}
        className="w-full h-56 object-cover"
      />

      <div className="p-4">
        <div className="flex items-center text-sm text-gray-500 mb-2">
          <span className="px-2 py-1 bg-gray-100 text-gray-700 rounded-full text-xs font-medium">
            {data?.category}
          </span>

          <div className="flex items-center ml-2">
            <Calendar className="h-3 w-3 mr-1" />
            {data?.createdAt && format(parseISO(data?.createdAt), "dd/MM/yyyy")}
          </div>

          <div className="flex items-center ml-2">
            <UserPen className="h-3 w-3 mr-1" />
            <span>{data?.author}</span>
          </div>
        </div>

        <h3 className="text-lg font-semibold text-gray-900 mb-2 line-clamp-2 transition-colors">
          {data?.title}
        </h3>

        {data?.sections[0]?.content && (
          <p className="text-gray-600 text-sm line-clamp-3 mb-2">
            {data?.sections[0].content}
          </p>
        )}

        <span className="text-[#33c7b6] text-sm font-medium hover:text-[#33c7b6]/60 transition-colors">
          Read more
        </span>
      </div>
    </div>
  );
};

export default BlogCard;
